<script setup lang="ts">
    import { Splide } from '@splidejs/vue-splide';
    import '@splidejs/vue-splide/css';

    defineProps<{
        options: object;
        extensions?: object;
    }>();
</script>

<template>
    <div class="slider-wrapper">
        <Splide
            :options="options"
            :extensions="extensions"
            class="splide"
        >
            <slot name="slides" />
        </Splide>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/slider.scss';
</style>
